export default __webpack_public_path__ + "static/media/lato-regular.1da63aaa.svg";